import { FC, useEffect } from 'react';
import { Typography } from 'antd';
import { TbArrowUpRight } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { NotionFormLink, PlanTag, PlatformAlert } from '@/shared';
import { useConnectedAccountStore } from '@/stores';

import AccountIntegrations from './layout/01-AccountIntegrations';
import ExistingAccountIntegrations from './layout/02-ExistingIntegrations';

const ConnectedAccounts: FC = (): JSX.Element => {
    const { token } = useAntDesignTheme();
    const { connectedAccounts, fetchConnectedAccounts } = useConnectedAccountStore();

    useEffect(() => {
        if (connectedAccounts.length === 0) {
            void fetchConnectedAccounts();
        }
    }, [connectedAccounts.length, fetchConnectedAccounts]);

    return (
        <>
            <Typography.Title id='settings-account-general-data-sources-section' level={4}>
                Data Sources
                <PlanTag plan={'plus'} style={{ verticalAlign: '0.1rem', marginLeft: '0.5rem' }} />
            </Typography.Title>
            <Typography.Paragraph>
                <span style={{ color: token.colorTextTertiary }}>
                    Connect & sync third-party services to Countercyclical. Learn more in
                </span>{' '}
                <a href='https://docs.countercyclical.io' target='_blank' rel='noopener noreferrer'>
                    our docs
                    <TbArrowUpRight style={{ verticalAlign: '-0.175rem', marginLeft: '0.125rem' }} />
                </a>
            </Typography.Paragraph>
            <PlatformAlert
                status='info'
                title='Organization-wide integrations'
                styles={{ marginBottom: '1rem' }}
                description={
                    <>
                        For organization-level syncing, feedback on this feature, or suggestions on other services to
                        add, please <NotionFormLink kind='support'>reach out</NotionFormLink>{' '}
                    </>
                }
            />
            <AccountIntegrations />
            <ExistingAccountIntegrations />
        </>
    );
};

export default ConnectedAccounts;
